import { LabelValue } from '@/types';

export const QUANTITY_RESERVES_OPTIONS: LabelValue[] = [
  { label: '2 reservas', value: '2' },
  { label: '3 reservas', value: '3' },
  { label: '4 reservas', value: '4' },
  { label: '5 reservas', value: '5' },
  { label: '6 reservas', value: '6' },
  { label: '7 reservas', value: '7' },
  { label: '8 reservas', value: '8' },
  { label: '9 reservas', value: '9' },
  { label: '10 reservas', value: '10' },
  { label: '11 reservas', value: '11' },
  { label: '12 reservas', value: '12' },
  { label: '13 reservas', value: '13' },
  { label: '14 reservas', value: '14' },
  { label: '15 reservas', value: '15' },
  { label: '16 reservas', value: '16' },
  { label: '17 reservas', value: '17' },
  { label: '18 reservas', value: '18' },
  { label: '19 reservas', value: '19' },
  { label: '20 reservas', value: '20' }
];
